export default function QueryStringParamRemover(
	queryParamString: string,
	paramName: string
): string {
	if (!queryParamString.includes(paramName + '=')) {
		return queryParamString;
	}
	let updatedQueryParamString = '';
	if (queryParamString.startsWith('?')) {
		queryParamString = queryParamString.replace('?', '');
	}
	let isFirstParam = true;
	const queryParams = queryParamString.split('&');
	queryParams.forEach((queryParam) => {
		const paramSeparator = isFirstParam ? '?' : '&';
		if (!queryParam.startsWith(paramName + '=')) {
			updatedQueryParamString = updatedQueryParamString + paramSeparator + queryParam;
			isFirstParam = false;
		}
	});
	return updatedQueryParamString;
}
